module.exports = __webpack_public_path__ + "static/media/saurabh_deulkar.e21ae5de.png";